import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=e3d7ee82&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3d7ee82')) {
      api.createRecord('e3d7ee82', component.options)
    } else {
      api.reload('e3d7ee82', component.options)
    }
    module.hot.accept("./Root.vue?vue&type=template&id=e3d7ee82&", function () {
      api.rerender('e3d7ee82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/Root.vue"
export default component.exports